import { Result } from 'antd';

export interface LocalizedMessage {
  readonly lang: string;
  readonly text: string;
}

/**
 * Shown when `/config.json` is missing or invalid. The brand (and so the language)
 * is unknown, so the message is shown in every language the product ships.
 */
export function ConfigErrorScreen({ messages }: { messages: readonly LocalizedMessage[] }) {
  return (
    <Result
      status="warning"
      title={messages.map(({ lang, text }) => (
        <p key={lang} lang={lang} style={{ margin: 0 }}>
          {text}
        </p>
      ))}
    />
  );
}
